// English data for packs

export const packsDataEN = [
  {
    id: 'pack-essentiel-mer-rouge',
    name: 'Red Sea Essentials',
    slug: 'pack-essentiel-mer-rouge',
    badge: '⭐ Most popular',
    subtitle: 'Hurghada must-dos made simple',
    image: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200,h_675,c_fill/v1767543316/orange-bay-hurghada-island_5_lf4q4c.jpg',
    activities: [
      { name: 'Orange Bay' },
      { name: 'Dolphin Day at Sea' }
    ],
    packPrice: 48,
    depositPrice: 10,
    remainingPrice: 38,
    popular: true,
    stripeLink: 'https://buy.stripe.com/dRmeVca6Fg1a4Cb4ZndMI00'
  },
  {
    id: 'pack-aventure-evasion',
    name: 'Adventure & Escape',
    slug: 'pack-aventure-evasion',
    badge: null,
    subtitle: 'Turquoise sea & unforgettable moments',
    image: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200,h_675,c_fill/v1767544721/horse-riding-hurghada_1_whlt0w.png',
    activities: [
      { name: 'Orange Bay' },
      { name: 'Horse Riding' }
    ],
    packPrice: 52,
    depositPrice: 15,
    remainingPrice: 37,
    popular: false,
    stripeLink: 'https://buy.stripe.com/5kQ14mgv3dT26KjgI5dMI01'
  },
  {
    id: 'pack-sejour-signature',
    name: 'Hurghada Signature Stay',
    slug: 'pack-sejour-signature',
    badge: null,
    subtitle: 'Egyptian culture & Red Sea combined',
    image: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200,h_675,c_fill/v1767545544/luxor-day-tour-valley-of-the-kings_2_o6wses.png',
    activities: [
      { name: 'Luxor 1 Day' },
      { name: 'Orange Bay' },
      { name: 'Dolphin Day at Sea' }
    ],
    packPrice: 115,
    depositPrice: 20,
    remainingPrice: 95,
    popular: false,
    stripeLink: 'https://buy.stripe.com/14AbJ0baJeX69Wv63rdMI02'
  }
];

export const packsFaqEN = [
  {
    question: 'What exactly does a package include?',
    answer: 'Each package includes several carefully selected excursions organized by reliable local partners. Transfers from your hotel, supervision and main activity are included depending on the excursion. Precise details are confirmed after booking.'
  },
  {
    question: 'Why book a package rather than separate activities?',
    answer: 'Packages are designed to simplify your organization, optimize your stay and get a better rate. It\'s the ideal solution if you\'re staying several days in Hurghada.'
  },
  {
    question: 'How does payment work?',
    answer: 'You book your package with a secure 20% deposit via Stripe. The balance is paid on the day of the excursion, directly to the local provider. No hidden payments, everything is clear from the start.'
  },
  {
    question: 'Can I ask questions before booking?',
    answer: 'Of course. I am your contact and I remain available on WhatsApp to answer all your questions before, during and after booking.'
  },
  {
    question: 'Are packages suitable for families and beginners?',
    answer: 'Yes. The excursions offered in packages are accessible to beginners and suitable for families, unless otherwise stated. Feel free to let me know the age of participants for confirmation.'
  },
  {
    question: 'What happens after booking the package?',
    answer: 'After your booking: I confirm availability, give you the times and pickup point, and you receive all practical information to enjoy your excursions with peace of mind.'
  }
];

export default { packsDataEN, packsFaqEN };
